// extracted by mini-css-extract-plugin
export default {"AppBody":"App_AppBody__P1uNx"};